import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Tables } from "@/integrations/supabase/types";
import { format } from "date-fns";

type Lead = Tables<"leads">;

export const EmploymentDetails = ({ lead }: { lead: Lead }) => (
  <Card className="mb-6">
    <CardHeader>
      <CardTitle>Employment Details</CardTitle>
    </CardHeader>
    <CardContent className="space-y-2">
      <div>
        <div className="font-medium">Employment Status</div>
        <div className="capitalize">
          {lead.employment_status?.replace(/_/g, " ") || "Not specified"}
        </div>
      </div>
      <div>
        <div className="font-medium">Years at Company</div>
        <div>{lead.years_at_company || "Not specified"}</div>
      </div>
      <div>
        <div className="font-medium">Last Day</div>
        <div>
          {lead.last_day
            ? format(new Date(lead.last_day), "MMMM d, yyyy")
            : "Not specified"}
        </div>
      </div>
    </CardContent>
  </Card>
);